import { ExternalLinkType } from '@everlywell/leaves';
import { Link } from 'gatsby';
import React from 'react';

export const customGatsbyLink: ExternalLinkType = ({
  href,
  children,
  ...rest
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <Link {...rest} to={href}>
    {children}
  </Link>
);

/*
 * shared function to remove the zoom campaign banner.
 * just re-export this from the page as `Head` per the gatsby docs
 * https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => (
  <style>
    {`#livesdk__campaign, #livesdk__campaign * {
        display: none !important;
      }`}
  </style>
);
